module.exports = __webpack_public_path__ + "img/1553011610.6b90e50a.jpg";